/**
 * Pure display helper for `customers.pool_type`.
 *
 * Lives apart from `customerLifecycle.js` on purpose: that module imports the
 * Supabase client for its mutation helpers, so anything importing a label from
 * it drags the DB client into the component tree (and into every test that
 * renders one). This file has no runtime dependencies beyond the passed-in intl.
 *
 * Unknown values pass through untranslated rather than vanishing — `Residential`
 * and `Commercial` predate the current six-value dropdown and may still sit on
 * old rows, and a non-pool tenant stores free-text site notes in this column.
 */
export function poolTypeDisplayLabel(poolType, intl) {
  if (!poolType) return '—';
  if (!intl) return poolType;
  const map = {
    'Vinyl': intl.formatMessage({ id: 'common.poolTypeVinyl', defaultMessage: 'Vinyl' }),
    'Gunite': intl.formatMessage({ id: 'common.poolTypeGunite', defaultMessage: 'Gunite' }),
    'Salt Water': intl.formatMessage({ id: 'common.poolTypeSaltWater', defaultMessage: 'Salt Water' }),
    'Gunite & Salt Water': intl.formatMessage({ id: 'common.poolTypeGuniteSalt', defaultMessage: 'Gunite & Salt Water' }),
    'Pool & Spa': intl.formatMessage({ id: 'common.poolTypeSpa', defaultMessage: 'Pool & Spa' }),
    'Pool & Spa (Salt Water)': intl.formatMessage({ id: 'common.poolTypeSpaSalt', defaultMessage: 'Pool & Spa (Salt Water)' }),
    'Residential': intl.formatMessage({ id: 'common.poolTypeResidential', defaultMessage: 'Residential' }),
    'Commercial': intl.formatMessage({ id: 'common.poolTypeCommercial', defaultMessage: 'Commercial' }),
  };
  return map[poolType] || poolType;
}
